/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import {Typography} from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsDescriptionStyles {
    wrapper?: InjectableCss;
}

export const descriptionStyles: ProductDetailsDescriptionStyles = {
    wrapper: {
        css: css`
            margin-bottom: 15px;
        `,
    },
};

const styles = descriptionStyles;

// xng-change: update the template
const ProductDetailsDescription: React.FC<Props> = ({ product }) => {
    const isBuildingBrand = product?.properties?.isBuildingBrand?.toLocaleLowerCase() === "true";
    const isHearthBrand = product?.properties?.isHearthBrand?.toLocaleLowerCase() === "true";
    const productContent = product?.content?.htmlContent || "";
    const isThereProductContent =
        productContent &&
        productContent.trim() !== "" &&
        productContent
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/\n/g, "")
            .replace(/\t/g, "");

    return (
        <StyledWrapper {...styles.wrapper}>
            <div data-test-selector="productDetails_htmlContent">
                {isThereProductContent && (
                    <>
                        <Typography variant="h3" as="h2">{translate('Product Overview')}</Typography>
                        {parse(productContent, parserOptions)}
                    </>
                )}
                {!isThereProductContent && isBuildingBrand && siteMessage("Custom_PDP_EcommerceDescription_Building")}
                {!isThereProductContent && isHearthBrand && siteMessage("Custom_PDP_EcommerceDescription_Hearth")}
            </div>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDescription),
    definition: {
        displayName: "Description",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
